import * as React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Typography } from "../mui";
import { CloseRoundedIcon } from "../icons";

/**
 * Reusable Modal Component
 * 
 * @param {boolean} open - Controls modal visibility
 * @param {function} onClose - Callback when modal is closed
 * @param {string} title - Modal title
 * @param {node} children - Modal content
 * @param {node} actions - Modal action buttons (footer)
 * @param {string} maxWidth - Max width of modal (xs, sm, md, lg, xl, false)
 * @param {boolean} fullWidth - Whether modal should take full width
 * @param {string} customWidth - Custom width (e.g., "600px", "80%") - overrides maxWidth
 */
export default function Modal({
  open = false,
  onClose,
  title,
  children,
  actions,
  maxWidth = "sm",
  fullWidth = true,
  customWidth,
  className = ""
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={customWidth ? false : maxWidth}
      fullWidth={customWidth ? false : fullWidth}
      className={`custom-modal ${className}`.trim()}
      PaperProps={{
        className: "custom-modal-paper",
        sx: customWidth ? { width: customWidth, maxWidth: customWidth } : {}
      }}
    >
      <DialogTitle className="custom-modal-header">
        <Typography variant="h6" component="div" className="custom-modal-title">
          {title}
        </Typography>
        <IconButton
          aria-label="close"
          onClick={onClose}
          className="custom-modal-close"
        >
          <CloseRoundedIcon />
        </IconButton>
      </DialogTitle>
      
      <DialogContent className="custom-modal-content">
        {children}
      </DialogContent>
      
      {actions && (
        <DialogActions className="custom-modal-actions">
          {actions}
        </DialogActions>
      )}
    </Dialog>
  );
}
